import { useQuery } from '@tanstack/react-query';

import { request } from '@utils';

export const useRetrieveDeclarantLogo = (declarantId: string, enabled: boolean) => {
  return useQuery({
    queryKey: ['declarant-logo', declarantId],
    enabled: enabled,
    queryFn: async () => {
      const res = await request({
        path: `declarant/${declarantId}/logo`,
        method: 'GET',
        authenticate: true,
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'arraybuffer',
      });

      if (!res) return null;

      const blob = new Blob([res], { type: 'image/png' });

      return await new Promise<string>((resolve) => {
        const reader = new FileReader();

        reader.onloadend = () => resolve(reader.result as string);
        reader.readAsDataURL(blob);
      });
    },
  });
};
